export default "__VITE_ASSET__BERxuBpT__"